/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { ReadMessageResponseJson } from './read-message-response-json';
import { ReadMessageResult } from '../results/read-message-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class ReadMessageResponse extends ResponseWithErrorGeneric<ReadMessageResponseJson, ReadMessageResult> implements IResponseWithErrorGeneric<ReadMessageResult> {
  public caseId: string = undefined;
  public messageId: string = undefined;

  //<custom-body>
  constructor(response: HttpResponse<ReadMessageResponse>) {
    super(response, ReadMessageResult.Error);
    if (this.result === ReadMessageResult.Success) {
      this.caseId = this.body.caseId;
      this.messageId = this.body.messageId;
    }
  }
  //</custom-body>
}
